module.exports = __webpack_public_path__ + "img/turbo_on.2a71b42d.png";